<div class="menu-more" (click)="closeMenu()">
  <div class="menu-more-wrapper" (click)="$event.stopPropagation()">
    <div class="menu-top">
      <div class="header">
        <span>{{'menu' | translate | uppercase}}</span>
        <i class="icon icon-close" (click)="closeMenu()"></i>
      </div>
      <div class="outlet">
        <div class="outlet-action">
           <div class="outlet-action-text">
             <i class="icon icon-shop"></i>
             <span>{{'address' | translate}}</span>
           </div>
          <button class="btn-secondary outlet-action-btn"
                  (click)="isShowChangeOutlet = true">
            {{'change' | translate}}
          </button>
        </div>
        <div class="outlet-info">
           <div class="outlet-info-address">{{supplierAndOutlet?.outletName}} {{supplierAndOutlet?.address}}</div>
           <div class="outlet-info-payers">
             <span>{{'sap-name' | translate}}: {{supplierAndOutlet?.supplierOutletCode}}</span>
           </div>
        </div>
      </div>
      <ul class="menu">
        <li *ngFor="let item of mainMenu" class="menu-item">
          <a mat-menu-item class="menu-item-link" (click)="clickMenu(item)" [ngClass]="item.itemCssClass">
            <div class="link-text">
              <i class="icon {{ item.url }}"></i>
              <span>{{ (item.nameMobile ? item.nameMobile : item.name) | translate }}</span>
            </div>
            <div>
              <span class="item-quantity" *ngIf="item?.quantity">{{ item.quantity }}</span>
              <i class="icon-error_2"></i>
              <i class="icon-arrow_right icon"></i>
            </div>
          </a>
        </li>
        <li class="menu-item">
          <div class="menu-item-link"  (click)="isShowUserNotifications = true">
            <div class="link-text">
              <i class="icon icon-notification"></i>
              <span>{{ 'user-notification.title' | translate }}</span>
            </div>
            <div class="notification-counter-wrap">
              <span class="notification-counter" *ngIf="notificationCounter > 0">
                {{ notificationCounter }}
              </span>
              <i class="icon-arrow_right icon"></i>
            </div>
          </div>
        </li>
        <li class="menu-item menu-item-log-out">
          <div class="menu-item-link"  (click)="logout()">
            <div class="link-text log-out">
              <i class="icon icon-logout"></i>
              <span>{{ 'exit' | translate }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="person-info" *ngIf="getSettingValue('responsiblePersonName')">
      <div class="person-info-header">{{'responsible-manager-message' | translate }}</div>
      <div  class="person-info-item">
        <i class="icon icon-manager"></i>
        <span>{{ getSettingValue('responsiblePersonFirstName') }} {{ getSettingValue('responsiblePersonLastName') }}</span>
      </div>
      <div class="person-info-link" *ngIf="getSettingValue('responsiblePersonPhone')">
        <i class="icon icon-phone"></i>
        <a class="link-item"  [attr.href]="'tel:' + getSettingValue('responsiblePersonPhone')">
          {{ getSettingValue('responsiblePersonPhone') }}
        </a>
      </div>
      <div class="person-info-link" *ngIf="getSettingValue('responsiblePersonEmail')">
        <i class="icon icon-email"></i>
        <a class="link-item" [attr.href]="'mailto:' + getSettingValue('responsiblePersonEmail')">
          {{ getSettingValue('responsiblePersonEmail') }}
        </a>
      </div>
    </div>
  </div>
  <div (click)="$event.stopPropagation()">
    <app-change-outlet
      *ngIf="isShowChangeOutlet"
      [mobile]="mobile"
      [isLoginSuperBusinessAdminOrBusinessAdmin]=" false"
      (closeAction)="isShowChangeOutlet = false"
    ></app-change-outlet>
  </div>
  <div (click)="$event.stopPropagation()">
    <app-user-notifications
      *ngIf="isShowUserNotifications"
      [mobile]="mobile"
      (closeNotifications)="isShowUserNotifications = false"
    ></app-user-notifications>
  </div>
</div>
